import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Typography,
    useTheme
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

const CustomDialog = ({
    isOpen,
    title = "Confirm",
    message = "Are you sure?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    onConfirm,
    onCancel,
    confirmColor = "primary",
    cancelColor = "inherit",
    icon = <WarningIcon fontSize="small" color='warning' />
}) => {
    const theme = useTheme();

    return (
        <Dialog
            open={isOpen}
            onClose={onCancel}
            PaperProps={{
                sx: {
                    borderRadius: '6px',
                    minWidth: '400px',
                    [theme.breakpoints.down('sm')]: {
                        minWidth: '90vw'
                    }
                }
            }}
        >
            <DialogTitle sx={{
                bgcolor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
            }}>
                {icon}
                <Typography variant="h6" component="span">{title}</Typography>
            </DialogTitle>

            <DialogContent sx={{ p: 1, mt: 2 }}>
                <Typography variant="body1">{message}</Typography>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button
                    variant="contained"
                    color={confirmColor}
                    onClick={onConfirm}
                    sx={{
                        textTransform: 'none',
                        // borderRadius: theme.shape.borderRadius
                    }}
                >
                    {confirmText}
                </Button>
                <Button
                    variant="outlined"
                    color={cancelColor}
                    onClick={onCancel}
                    sx={{
                        textTransform: 'none',
                        // borderRadius: theme.shape.borderRadius
                    }}
                >
                    {cancelText}
                </Button>

            </DialogActions>
        </Dialog>
    );
};

export default CustomDialog;